import { createContext, useContext } from "react";
import { useTranslation } from "react-i18next";

import { moneyFormat } from "../../../../../plugins/numberFormat";
import { copyText, envChangeType } from "../../../../../plugins/utils";
import Dice from "../../../../ColorGame/components/Dice";
import {
  betResultColorMapping,
  resultColorMapping,
} from "../../../../ColorGame/enumeration/resultColorMapping";
import CopyIcon from "../../icons/CopyIcon";
import styles from "./style.module.scss";

const ColumnsContext = createContext({
  getColumns: () => {},
});
export const ColumnsContextProvider = (props) => {
  const { t, i18n } = useTranslation();
  const getLang = () => i18n.language;
  // console.log("nowLang", getLang());

  const render77ChoiceNumber = (val) => {
    const itemSorting = (a, b) => {
      if (isNaN(parseInt(a)) && isNaN(parseInt(b))) {
        return 1;
      }
      return parseInt(a) - parseInt(b);
    };

    if (typeof val === "string") {
      const valSplit = val.split("|");
      return valSplit
        .map((_val) => {
          return (
            _val
              .split(",")
              .sort(itemSorting)
              //because parseInt(7X)=7
              .map((v) =>
                v.includes("X")
                  ? t(`lottery.item.${v}`)
                  : isNaN(parseInt(v)) && v !== "_" && v !== ""
                    ? t(`lottery.item.${v}`)
                    : v,
              )
              .join(",")
          );
        })
        .join("|");
    } else {
      return val;
    }
  };

  const renderCopyableTransId = (record) => {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <span style={{ marginRight: "2px" }}>{record.trans_id}</span>
        <span
          onClick={() => {
            copyText(record.trans_id, t("normal.copy.complete"));
          }}
          style={{ cursor: "pointer" }}
        >
          <CopyIcon />
        </span>
      </div>
    );
  };

  const renderGeneralWinlost = ({
    total_win_lose,
    status,
    showWinLostStatus = [],
    unsettleStatus = [],
  }) => {
    if (total_win_lose === null || unsettleStatus.includes(status)) return t("betRecord.unsettled");
    if (showWinLostStatus.length <= 0 || showWinLostStatus.includes(status)) {
      return (
        <span
          style={{
            color: total_win_lose > 0 ? "var(--ant-success-color)" : "var(--ant-error-color)",
          }}
        >
          {moneyFormat(total_win_lose)}
        </span>
      );
    }
    return "-";
  };

  const getColumns = (game) => {
    const sabaColumns = [
      {
        title: t("betRecord.bet"),
        dataIndex: "debit_amount",
        render: (data) => {
          return moneyFormat(data?.debit_amount);
        },
      },
      {
        title: t("betRecord.winAmount"),
        dataIndex: "earn_amount",
        render: (data) => {
          const UNSETTLE_STATUS = [2];
          const SHOW_WIN_LOSS_STATUS = [4, 5, 6, 7, 8];
          return renderGeneralWinlost({
            total_win_lose: data.earn_amount,
            status: data.status,
            showWinLostStatus: SHOW_WIN_LOSS_STATUS,
            unsettleStatus: UNSETTLE_STATUS,
          });
        },
      },
      {
        title: t("betRecord.game.type"),
        dataIndex: "sport_name",
        render: (data) => {
          const detailData = data.ticket_detail?.length > 0 ? data.ticket_detail[0] : {};
          return <>{data.txns !== null ? t("betRecord.saba.parlay") : detailData?.sportTypeName}</>;
        },
      },
      {
        title: t("betRecord.transId"),
        dataIndex: "trans_id",
        collapse: true,
        render: (data) => renderCopyableTransId(data),
      },
      {
        title: t("betRecord.settleTime"),
        dataIndex: "settlement_time",
        collapse: true,
      },
      {
        title: t("betRecord.league"),
        dataIndex: "league_name",
        collapse: true,
        render: (data) => {
          const detailData = data.ticket_detail?.length > 0 ? data.ticket_detail[0] : {};
          return <>{data.txns !== null ? t("betRecord.saba.parlay") : detailData?.leagueName}</>;
        },
      },
      {
        title: t("betRecord.homeTeam"),
        dataIndex: "home_name",
        collapse: true,
        render: (data) => {
          const detailData = data.ticket_detail?.length > 0 ? data.ticket_detail[0] : {};
          return <>{data.txns !== null ? t("betRecord.saba.parlay") : detailData?.homeName}</>;
        },
      },
      {
        title: t("betRecord.awayTeam"),
        dataIndex: "away_name",
        collapse: true,
        render: (data) => {
          const detailData = data.ticket_detail?.length > 0 ? data.ticket_detail[0] : {};
          return <>{data.txns !== null ? t("betRecord.saba.parlay") : detailData?.awayName}</>;
        },
      },
      {
        title: t("betRecord.status"),
        dataIndex: "status",
        collapse: true,
        render: (data) => {
          return <>{t(`betRecord.saba.status${data.status}`)}</>;
        },
      },
    ];
    const jollySportColumns = [
      {
        title: t("betRecord.bet"),
        dataIndex: "debit_amount",
        render: (data) => {
          return moneyFormat(data?.debit_amount);
        },
      },
      {
        title: t("betRecord.winAmount"),
        dataIndex: "earn_amount",
        render: (data) => {
          const UNSETTLE_STATUS = [2];
          const SHOW_WIN_LOSS_STATUS = [4, 5, 6, 7, 8];
          return renderGeneralWinlost({
            total_win_lose: data.earn_amount,
            status: data.status,
            showWinLostStatus: SHOW_WIN_LOSS_STATUS,
            unsettleStatus: UNSETTLE_STATUS,
          });
        },
      },
      {
        title: t("betRecord.game.type"),
        dataIndex: "sport_name",
        render: (data) => {
          const detailData = data.ticket_detail?.length > 0 ? data.ticket_detail[0] : {};
          return <>{data.txns !== null ? t("betRecord.saba.parlay") : detailData?.sportTypeName}</>;
        },
      },
      {
        title: t("betRecord.transId"),
        dataIndex: "trans_id",
        collapse: true,
        render: (data) => renderCopyableTransId(data),
      },
      {
        title: t("betRecord.settleTime"),
        dataIndex: "settlement_time",
        collapse: true,
      },
      {
        title: t("betRecord.league"),
        dataIndex: "league_name",
        collapse: true,
        render: (data) => {
          const detailData = data.ticket_detail?.length > 0 ? data.ticket_detail[0] : {};
          return <>{data.txns !== null ? t("betRecord.saba.parlay") : detailData?.leagueName}</>;
        },
      },
      {
        title: t("betRecord.homeTeam"),
        dataIndex: "home_name",
        collapse: true,
        render: (data) => {
          const detailData = data.ticket_detail?.length > 0 ? data.ticket_detail[0] : {};
          return <>{data.txns !== null ? t("betRecord.saba.parlay") : detailData?.homeName}</>;
        },
      },
      {
        title: t("betRecord.awayTeam"),
        dataIndex: "away_name",
        collapse: true,
        render: (data) => {
          const detailData = data.ticket_detail?.length > 0 ? data.ticket_detail[0] : {};
          return <>{data.txns !== null ? t("betRecord.saba.parlay") : detailData?.awayName}</>;
        },
      },
      {
        title: t("betRecord.status"),
        dataIndex: "status",
        collapse: true,
        render: (data) => {
          return <>{t(`betRecord.saba.status${data.status}`)}</>;
        },
      },
    ];
    const blockchainColumns = [
      {
        title: t("betRecord.bet"),
        dataIndex: "stake",
        render: (data) => {
          return moneyFormat(data?.stake);
        },
      },
      {
        title: t("betRecord.winAmount"),
        dataIndex: "winlost_amount",

        render: (data) => {
          return renderGeneralWinlost({
            total_win_lose: data.winlost_amount,
            status: data.status,
          });
        },
      },
      {
        title: t("betRecord.game.type"),
        dataIndex: "game_code",
        render: (data) => {
          return t([
            `betRecord.games.${envChangeType("REACT_APP_PRODUCTION_NAME_DEV")}.${data.game_code}`,
            `betRecord.games.${data.game_code}`,
          ]);
        },
      },
      {
        title: t("betRecord.period"),
        dataIndex: "period",
        collapse: true,
      },
      {
        title: t("betRecord.transId"),
        dataIndex: "trans_id",
        collapse: true,
        render: (data) => renderCopyableTransId(data),
      },
      {
        title: t("betRecord.settleTime"),
        dataIndex: "settlement_time",
        collapse: true,
      },
      {
        title: t("betRecord.status"),
        dataIndex: "status",
        collapse: true,
        render: (data) => {
          return t(`betRecord.general.status${data.status}`);
        },
      },
    ];
    const bglotteryColumns = [
      {
        title: t("betRecord.bet"),
        dataIndex: "bet_amount",
        render: (data) => {
          return moneyFormat(data?.bet_amount);
        },
      },
      {
        title: t("betRecord.winAmount"),
        dataIndex: "payout",
        render: (data) => {
          return renderGeneralWinlost({
            total_win_lose: data.payout,
            status: data.order_status,
          });
        },
      },
      {
        title: t("betRecord.game.type"),
        dataIndex: "lottery_name",
      },
      {
        title: t("betRecord.period"),
        dataIndex: "issue",
      },
      {
        title: t("betRecord.transId"),
        dataIndex: "trans_id",
        collapse: true,
        render: (data) => renderCopyableTransId(data),
      },
      {
        title: t("betRecord.settleTime"),
        dataIndex: "settlement_time",
        collapse: true,
      },
      {
        title: t("betRecord.status"),
        dataIndex: "order_status",
        collapse: true,
        render: (data) => {
          return t(`betRecord.bglottery.status${data.order_status}`);
        },
      },
    ];
    const lottery77Columns = [
      {
        title: t("betRecord.bet"),
        dataIndex: "total_bet_point",
        render: (data) => {
          return moneyFormat(data?.total_bet_point);
        },
      },
      {
        title: t("betRecord.winAmount"),
        dataIndex: "total_win_lose",
        render: (data) => {
          const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
          return renderGeneralWinlost({
            total_win_lose: data.total_win_lose,
            status: data.status,
            showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          });
        },
      },
      {
        title: t("betRecord.game.type"),
        dataIndex: "game_type",
        render: (data) => {
          return t(`betRecord.77lottery.gameType.${data.game_type}`);
        },
      },
      {
        title: t("game.winlottery.betContent"),
        dataIndex: "choice_number",
        render: (data) => {
          return (
            <span>{`【${t(`gameWay.${data.game_way_type}`)} ${
              data.game_way_detail_type ? `-${t(`gameWay.${data.game_way_detail_type}`)}` : ""
            }】${render77ChoiceNumber(data?.choice_number)}`}</span>
          );
        },
      },
      {
        title: t("betRecord.period"),
        dataIndex: "period",
        collapse: true,
      },
      {
        title: t("betRecord.transId"),
        dataIndex: "trans_id",
        collapse: true,
        render: (data) => renderCopyableTransId(data),
      },
      {
        title: t("betRecord.settleTime"),
        dataIndex: "settlement_time",
        collapse: true,
      },
      {
        title: t("betRecord.status"),
        dataIndex: "status",
        collapse: true,
        render: (data) => {
          return t(`betRecord.general.status${data.status}`);
        },
      },
    ];
    const mgColumns = [
      {
        title: t("betRecord.bet"),
        dataIndex: "bet_point",
        render: (data) => {
          return moneyFormat(data?.bet_point);
        },
      },
      {
        title: t("betRecord.winAmount"),
        dataIndex: "total_win_lose",
        render: (data) => {
          const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
          return renderGeneralWinlost({
            total_win_lose: data.total_win_lose,
            status: data.status,
            showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          });
        },
      },
      {
        title: t("betRecord.game.type"),
        dataIndex: "game_name",
        render: (data) => {
          const nowLang = getLang();
          return nowLang === "zh" ? data.chinese_game_name : data.game_name;
        },
      },
      // {
      //   title: t("betRecord.period"),
      //   dataIndex: "period",
      //   collapse: true,
      // },
      {
        title: t("betRecord.transId"),
        dataIndex: "trans_id",
        collapse: true,
        render: (data) => renderCopyableTransId(data),
      },
      {
        title: t("betRecord.settleTime"),
        dataIndex: "settlement_time",
        collapse: true,
      },
      {
        title: t("betRecord.status"),
        dataIndex: "status",
        collapse: true,
        render: (data) => {
          return t(`betRecord.general.status${data.status}`);
        },
      },
    ];
    const winColumns = [
      {
        title: t("betRecord.bet"),
        dataIndex: "total_bet_point",
        render: (data) => {
          return moneyFormat(data?.total_bet_point);
        },
      },
      {
        title: t("normal.handlingFee"),
        dataIndex: "fee",
        render: (data) => {
          return moneyFormat(data?.fee);
        },
      },
      {
        title: t("betRecord.winAmount"),
        dataIndex: "total_win_lose",
        render: (data) => {
          const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
          return renderGeneralWinlost({
            total_win_lose: data.total_win_lose,
            status: data.status,
            showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          });
        },
      },
      {
        title: t("betRecord.game.type"),
        dataIndex: "game_type",
        render: (data) => {
          return t([
            `${envChangeType("REACT_APP_WIN_TRAN_NAME")}.betRecord.wingame.gameType.${data.game_type}`,
            `win.betRecord.wingame.gameType.${data.game_type}`,
          ]);
        },
      },
      {
        title: t("game.winlottery.betContent"),
        dataIndex: "choice_number",
        render: (data) => {
          if (data.game_category_detail_type === "LOTBIT") {
            return <span>{t(`win.bitgame.bettype.${data?.choice_number}`)}</span>;
          }
          if (data.game_category_detail_type === "LOTCOLOR") {
            return <Dice color={betResultColorMapping[data.choice_number]} />;
          }

          if (isNaN(parseInt(data?.choice_number)))
            return <span>{t(`win.wingame.bettype.${data?.choice_number}`)}</span>;
          return <span>{t(`${data?.choice_number}`)}</span>;
        },
      },
      {
        title: t("betRecord.resultNumber"),
        dataIndex: "lottery_number",
        render: (data) => {
          if (!data.lottery_number) return <span>{t("betRecord.resultNumber.notDrawn")}</span>;
          if (data.game_category_detail_type === "LOTBIT") {
            return JSON.parse(data.lottery_number).period_result_bit.current_amount || "";
          } else if (data.game_category_detail_type === "LOTCOLOR") {
            const arr = JSON.parse(data.lottery_number).period_result_number;
            return (
              <div className={styles.colorResult}>
                {arr.map((color) => {
                  return <Dice color={resultColorMapping[color]} />;
                })}
              </div>
            );
          } else {
            return JSON.parse(data.lottery_number).period_result_number[0] || "";
          }
        },
      },
      {
        title: t("betRecord.period"),
        dataIndex: "period",
        collapse: true,
      },
      {
        title: t("betRecord.transId"),
        dataIndex: "trans_id",
        collapse: true,
        render: (data) => renderCopyableTransId(data),
      },
      {
        title: t("betRecord.settleTime"),
        dataIndex: "settlement_time",
        collapse: true,
      },
      {
        title: t("betRecord.status"),
        dataIndex: "status",
        collapse: true,
        render: (data) => {
          return t(`betRecord.general.status${data.status}`);
        },
      },
    ];
    const t1Columns = [
      {
        title: t("betRecord.bet"),
        dataIndex: "stake",
        render: (data) => {
          return moneyFormat(data?.stake);
        },
      },
      {
        title: t("game.winlottery.betContent"),
        dataIndex: "bet_content",
        render: (data) => {
          return data?.bet_content === null ? "-" : <div>{data.bet_content}</div>;
        },
      },
      {
        title: t("betRecord.winAmount"),
        dataIndex: "total_win_lose",
        render: (data) => {
          const SHOW_WIN_LOSS_STATUS = [1, 4, 5];
          return renderGeneralWinlost({
            total_win_lose: data.total_win_lose,
            status: data.status,
            showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          });
        },
      },
      {
        title: t("betRecord.game.type"),
        dataIndex: "game_code",
        render: (data) => {
          return <span style={{ textTransform: "capitalize" }}>{data.game_code}</span>;
        },
      },
      {
        title: t("betRecord.period"),
        dataIndex: "period",
        collapse: true,
      },
      {
        title: t("betRecord.transId"),
        dataIndex: "trans_id",
        collapse: true,
        render: (data) => renderCopyableTransId(data),
      },
      {
        title: t("betRecord.settleTime"),
        dataIndex: "settlement_time",
        collapse: true,
      },
      {
        title: t("betRecord.status"),
        dataIndex: "status",
        collapse: true,
        render: (data) => {
          return t(`betRecord.t1.status${data.status}`);
        },
      },
    ];
    const evoColumns = [
      {
        title: t("betRecord.bet"),
        dataIndex: "stake",
        render: (data) => {
          return moneyFormat(data?.stake);
        },
      },
      {
        title: t("betRecord.winAmount"),
        dataIndex: "total_win_lose",
        render: (data) => {
          const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
          return renderGeneralWinlost({
            total_win_lose: data.total_win_lose,
            status: data.status,
            showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          });
        },
      },
      {
        title: t("betRecord.game.type"),
        dataIndex: "game_code",
        render: (data) => {
          return t(`evo.gameType.${data.game_code}`);
        },
      },
      {
        title: t("betRecord.transId"),
        dataIndex: "trans_id",
        collapse: true,
        render: (data) => renderCopyableTransId(data),
      },
      {
        title: t("betRecord.settleTime"),
        dataIndex: "settlement_time",
        collapse: true,
      },
      {
        title: t("betRecord.status"),
        dataIndex: "status",
        collapse: true,
        render: (data) => {
          return t(`betRecord.evo.status${data.status}`);
        },
      },
    ];
    const ppColumns = [
      {
        title: t("betRecord.bet"),
        dataIndex: "bet_point",
        render: (data) => {
          return moneyFormat(data?.bet_point);
        },
      },
      {
        title: t("betRecord.winAmount"),
        dataIndex: "total_win_lose",
        render: (data) => {
          const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
          return renderGeneralWinlost({
            total_win_lose: data.total_win_lose,
            status: data.status,
            showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          });
        },
      },
      {
        title: t("betRecord.game.type"),
        dataIndex: "name",
      },
      {
        title: t("betRecord.transId"),
        dataIndex: "trans_id",
        collapse: true,
        render: (data) => renderCopyableTransId(data),
      },
      {
        title: t("betRecord.settleTime"),
        dataIndex: "settlement_time",
        collapse: true,
      },
      {
        title: t("betRecord.status"),
        dataIndex: "status",
        collapse: true,
        render: (data) => {
          return t(`betRecord.general.status${data.status}`);
        },
      },
    ];
    const pgColumns = [
      {
        title: t("betRecord.bet"),
        dataIndex: "bet_point",
        render: (data) => {
          return moneyFormat(data?.bet_point);
        },
      },
      {
        title: t("betRecord.winAmount"),
        dataIndex: "total_win_lose",
        render: (data) => {
          const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
          return renderGeneralWinlost({
            total_win_lose: data.total_win_lose,
            status: data.status,
            showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          });
        },
      },
      {
        title: t("betRecord.game.type"),
        dataIndex: "name",
      },
      {
        title: t("betRecord.transId"),
        dataIndex: "trans_id",
        collapse: true,
        render: (data) => renderCopyableTransId(data),
      },
      {
        title: t("betRecord.settleTime"),
        dataIndex: "settlement_time",
        collapse: true,
      },
      {
        title: t("betRecord.status"),
        dataIndex: "status",
        collapse: true,
        render: (data) => {
          return t(`betRecord.general.status${data.status}`);
        },
      },
    ];

    const yggColumns = [
      {
        title: t("betRecord.bet"),
        dataIndex: "bet_point",
        render: (data) => {
          return moneyFormat(data?.bet_point);
        },
      },
      {
        title: t("betRecord.winAmount"),
        dataIndex: "total_win_lose",
        render: (data) => {
          const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
          return renderGeneralWinlost({
            total_win_lose: data.total_win_lose,
            status: data.status,
            showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          });
        },
      },
      {
        title: t("betRecord.game.type"),
        dataIndex: "name",
      },
      {
        title: t("betRecord.transId"),
        dataIndex: "trans_id",
        collapse: true,
        render: (data) => renderCopyableTransId(data),
      },
      {
        title: t("betRecord.settleTime"),
        dataIndex: "settlement_time",
        collapse: true,
      },
      {
        title: t("betRecord.status"),
        dataIndex: "status",
        collapse: true,
        render: (data) => {
          return t(`betRecord.general.status${data.status}`);
        },
      },
    ];
    const evoplayColumns = [
      {
        title: t("betRecord.bet"),
        dataIndex: "bet_point",
        render: (data) => {
          return moneyFormat(data?.bet_point);
        },
      },
      {
        title: t("betRecord.winAmount"),
        dataIndex: "total_win_lose",
        render: (data) => {
          const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
          return renderGeneralWinlost({
            total_win_lose: data.total_win_lose,
            status: data.status,
            showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          });
        },
      },
      {
        title: t("betRecord.game.type"),
        dataIndex: "name",
      },
      {
        title: t("betRecord.transId"),
        dataIndex: "trans_id",
        collapse: true,
        render: (data) => renderCopyableTransId(data),
      },
      {
        title: t("betRecord.settleTime"),
        dataIndex: "settlement_time",
        collapse: true,
      },
      {
        title: t("betRecord.status"),
        dataIndex: "status",
        collapse: true,
        render: (data) => {
          return t(`betRecord.general.status${data.status}`);
        },
      },
    ];

    const jiliColumns = [
      {
        title: t("betRecord.bet"),
        dataIndex: "bet_point",
        render: (data) => {
          return moneyFormat(data?.bet_point);
        },
      },
      {
        title: t("betRecord.winAmount"),
        dataIndex: "total_win_lose",
        render: (data) => {
          const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
          return renderGeneralWinlost({
            total_win_lose: data.total_win_lose,
            status: data.status,
            showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          });
        },
      },
      {
        title: t("betRecord.game.type"),
        dataIndex: "name",
      },
      {
        title: t("betRecord.transId"),
        dataIndex: "trans_id",
        collapse: true,
        render: (data) => renderCopyableTransId(data),
      },
      {
        title: t("betRecord.settleTime"),
        dataIndex: "settlement_time",
        collapse: true,
      },
      {
        title: t("betRecord.status"),
        dataIndex: "status",
        collapse: true,
        render: (data) => {
          return t(`betRecord.general.status${data.status}`);
        },
      },
    ];
    const spribeColumns = [
      {
        title: t("betRecord.bet"),
        dataIndex: "bet_point",
        render: (data) => {
          return moneyFormat(data?.bet_point);
        },
      },
      {
        title: t("betRecord.winAmount"),
        dataIndex: "total_win_lose",
        render: (data) => {
          const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
          return renderGeneralWinlost({
            total_win_lose: data.total_win_lose,
            status: data.status,
            showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          });
        },
      },
      {
        title: t("betRecord.game.type"),
        dataIndex: "name",
      },
      {
        title: t("betRecord.transId"),
        dataIndex: "trans_id",
        collapse: true,
        render: (data) => renderCopyableTransId(data),
      },
      {
        title: t("betRecord.settleTime"),
        dataIndex: "settlement_time",
        collapse: true,
      },
      {
        title: t("betRecord.status"),
        dataIndex: "status",
        collapse: true,
        render: (data) => {
          return t(`betRecord.general.status${data.status}`);
        },
      },
    ];
    const ptColumns = [
      {
        title: t("betRecord.bet"),
        dataIndex: "bet_point",
        render: (data) => {
          return moneyFormat(data?.bet_point);
        },
      },
      {
        title: t("betRecord.winAmount"),
        dataIndex: "total_win_lose",
        render: (data) => {
          const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
          return renderGeneralWinlost({
            total_win_lose: data.total_win_lose,
            status: data.status,
            showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          });
        },
      },
      {
        title: t("betRecord.game.type"),
        dataIndex: "name",
      },
      {
        title: t("betRecord.transId"),
        dataIndex: "trans_id",
        collapse: true,
        render: (data) => renderCopyableTransId(data),
      },
      {
        title: t("betRecord.settleTime"),
        dataIndex: "settlement_time",
        collapse: true,
      },
      {
        title: t("betRecord.status"),
        dataIndex: "status",
        collapse: true,
        render: (data) => {
          return t(`betRecord.general.status${data.status}`);
        },
      },
    ];

    const ppliveColumns = [
      {
        title: t("betRecord.bet"),
        dataIndex: "bet_point",
        render: (data) => {
          return moneyFormat(data?.bet_point);
        },
      },
      {
        title: t("betRecord.winAmount"),
        dataIndex: "total_win_lose",
        render: (data) => {
          const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
          return renderGeneralWinlost({
            total_win_lose: data.total_win_lose,
            status: data.status,
            showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          });
        },
      },
      {
        title: t("betRecord.game.type"),
        dataIndex: "name",
      },
      {
        title: t("betRecord.transId"),
        dataIndex: "trans_id",
        collapse: true,
        render: (data) => renderCopyableTransId(data),
      },
      {
        title: t("betRecord.settleTime"),
        dataIndex: "settlement_time",
        collapse: true,
      },
      {
        title: t("betRecord.status"),
        dataIndex: "status",
        collapse: true,
        render: (data) => {
          return t(`betRecord.general.status${data.status}`);
        },
      },
    ];
    const fcColumns = [
      {
        title: t("betRecord.bet"),
        dataIndex: "bet_point",
        render: (data) => {
          return moneyFormat(data?.bet_point);
        },
      },
      {
        title: t("betRecord.winAmount"),
        dataIndex: "total_win_lose",
        render: (data) => {
          const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
          return renderGeneralWinlost({
            total_win_lose: data.total_win_lose,
            status: data.status,
            showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          });
        },
      },
      {
        title: t("betRecord.game.type"),
        dataIndex: "name",
      },
      {
        title: t("betRecord.transId"),
        dataIndex: "trans_id",
        collapse: true,
        render: (data) => renderCopyableTransId(data),
      },
      {
        title: t("betRecord.settleTime"),
        dataIndex: "settlement_time",
        collapse: true,
      },
      {
        title: t("betRecord.status"),
        dataIndex: "status",
        collapse: true,
        render: (data) => {
          return t(`betRecord.general.status${data.status}`);
        },
      },
    ];
    const cq9Columns = [
      {
        title: t("betRecord.bet"),
        dataIndex: "bet_point",
        render: (data) => {
          return moneyFormat(data?.bet_point);
        },
      },
      {
        title: t("betRecord.winAmount"),
        dataIndex: "total_win_lose",
        render: (data) => {
          const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
          return renderGeneralWinlost({
            total_win_lose: data.total_win_lose,
            status: data.status,
            showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          });
        },
      },
      {
        title: t("betRecord.game.type"),
        dataIndex: "name",
      },
      {
        title: t("betRecord.transId"),
        dataIndex: "trans_id",
        collapse: true,
        render: (data) => renderCopyableTransId(data),
      },
      {
        title: t("betRecord.settleTime"),
        dataIndex: "settlement_time",
        collapse: true,
      },
      {
        title: t("betRecord.status"),
        dataIndex: "status",
        collapse: true,
        render: (data) => {
          return t(`betRecord.general.status${data.status}`);
        },
      },
    ];
    const playstarColumns = [
      {
        title: t("betRecord.bet"),
        dataIndex: "bet_point",
        render: (data) => {
          return moneyFormat(data?.bet_point);
        },
      },
      {
        title: t("betRecord.winAmount"),
        dataIndex: "total_win_lose",
        render: (data) => {
          const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
          return renderGeneralWinlost({
            total_win_lose: data.total_win_lose,
            status: data.status,
            showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          });
        },
      },
      {
        title: t("betRecord.game.type"),
        dataIndex: "name",
      },
      {
        title: t("betRecord.transId"),
        dataIndex: "trans_id",
        collapse: true,
        render: (data) => renderCopyableTransId(data),
      },
      {
        title: t("betRecord.settleTime"),
        dataIndex: "settlement_time",
        collapse: true,
      },
      {
        title: t("betRecord.status"),
        dataIndex: "status",
        collapse: true,
        render: (data) => {
          return t(`betRecord.general.status${data.status}`);
        },
      },
    ];

    const weliveColumns = [
      {
        title: t("betRecord.bet"),
        dataIndex: "bet_point",
        render: (data) => {
          return moneyFormat(data?.bet_point);
        },
      },
      {
        title: t("betRecord.winAmount"),
        dataIndex: "total_win_lose",
        render: (data) => {
          const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
          return renderGeneralWinlost({
            total_win_lose: data.total_win_lose,
            status: data.status,
            showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          });
        },
      },
      {
        title: t("betRecord.game.type"),
        dataIndex: "name",
      },
      {
        title: t("betRecord.transId"),
        dataIndex: "trans_id",
        collapse: true,
        render: (data) => renderCopyableTransId(data),
      },
      {
        title: t("betRecord.settleTime"),
        dataIndex: "settlement_time",
        collapse: true,
      },
      {
        title: t("betRecord.status"),
        dataIndex: "status",
        collapse: true,
        render: (data) => {
          return t(`betRecord.general.status${data.status}`);
        },
      },
    ];

    const weblockchainColumns = [
      {
        title: t("betRecord.bet"),
        dataIndex: "bet_point",
        render: (data) => {
          return moneyFormat(data?.bet_point);
        },
      },
      {
        title: t("betRecord.winAmount"),
        dataIndex: "total_win_lose",
        render: (data) => {
          const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
          return renderGeneralWinlost({
            total_win_lose: data.total_win_lose,
            status: data.status,
            showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          });
        },
      },
      {
        title: t("betRecord.game.type"),
        dataIndex: "name",
      },
      {
        title: t("betRecord.transId"),
        dataIndex: "trans_id",
        collapse: true,
        render: (data) => renderCopyableTransId(data),
      },
      {
        title: t("betRecord.settleTime"),
        dataIndex: "settlement_time",
        collapse: true,
      },
      {
        title: t("betRecord.status"),
        dataIndex: "status",
        collapse: true,
        render: (data) => {
          return t(`betRecord.general.status${data.status}`);
        },
      },
    ];

    const welotteryColumns = [
      {
        title: t("betRecord.bet"),
        dataIndex: "bet_point",
        render: (data) => {
          return moneyFormat(data?.bet_point);
        },
      },
      {
        title: t("betRecord.winAmount"),
        dataIndex: "total_win_lose",
        render: (data) => {
          const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
          return renderGeneralWinlost({
            total_win_lose: data.total_win_lose,
            status: data.status,
            showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          });
        },
      },
      {
        title: t("betRecord.game.type"),
        dataIndex: "name",
      },
      {
        title: t("betRecord.transId"),
        dataIndex: "trans_id",
        collapse: true,
        render: (data) => renderCopyableTransId(data),
      },
      {
        title: t("betRecord.settleTime"),
        dataIndex: "settlement_time",
        collapse: true,
      },
      {
        title: t("betRecord.status"),
        dataIndex: "status",
        collapse: true,
        render: (data) => {
          return t(`betRecord.general.status${data.status}`);
        },
      },
    ];
    const tcgColumns = [
      {
        title: t("betRecord.bet"),
        dataIndex: "bet_point",
        render: (data) => {
          return moneyFormat(data?.bet_point);
        },
      },
      {
        title: t("betRecord.winAmount"),
        dataIndex: "total_win_lose",
        render: (data) => {
          const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
          return renderGeneralWinlost({
            total_win_lose: data.total_win_lose,
            status: data.status,
            showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          });
        },
      },
      {
        title: t("betRecord.game.type"),
        dataIndex: "name",
      },
      {
        title: t("betRecord.transId"),
        dataIndex: "trans_id",
        collapse: true,
        render: (data) => renderCopyableTransId(data),
      },
      {
        title: t("betRecord.settleTime"),
        dataIndex: "settlement_time",
        collapse: true,
      },
      {
        title: t("betRecord.status"),
        dataIndex: "status",
        collapse: true,
        render: (data) => {
          return t(`betRecord.general.status${data.status}`);
        },
      },
    ];
    const jilifishColumns = [
      {
        title: t("betRecord.bet"),
        dataIndex: "bet_point",
        render: (data) => {
          return moneyFormat(data?.bet_point);
        },
      },
      {
        title: t("betRecord.winAmount"),
        dataIndex: "total_win_lose",
        render: (data) => {
          const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
          return renderGeneralWinlost({
            total_win_lose: data.total_win_lose,
            status: data.status,
            showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          });
        },
      },
      {
        title: t("betRecord.game.type"),
        dataIndex: "name",
      },
      {
        title: t("betRecord.transId"),
        dataIndex: "trans_id",
        collapse: true,
        render: (data) => renderCopyableTransId(data),
      },
      {
        title: t("betRecord.settleTime"),
        dataIndex: "settlement_time",
        collapse: true,
      },
      {
        title: t("betRecord.status"),
        dataIndex: "status",
        collapse: true,
        render: (data) => {
          return t(`betRecord.general.status${data.status}`);
        },
      },
    ];
    const youbetColumns = [
      {
        title: t("betRecord.bet"),
        dataIndex: "bet_point",
        render: (data) => {
          return moneyFormat(data?.bet_point);
        },
      },
      {
        title: t("betRecord.winAmount"),
        dataIndex: "total_win_lose",
        render: (data) => {
          const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
          return renderGeneralWinlost({
            total_win_lose: data.total_win_lose,
            status: data.status,
            showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          });
        },
      },
      {
        title: t("betRecord.game.type"),
        dataIndex: "name",
      },
      {
        title: t("betRecord.transId"),
        dataIndex: "trans_id",
        collapse: true,
        render: (data) => renderCopyableTransId(data),
      },
      {
        title: t("betRecord.settleTime"),
        dataIndex: "settlement_time",
        collapse: true,
      },
      {
        title: t("betRecord.status"),
        dataIndex: "status",
        collapse: true,
        render: (data) => {
          return t(`betRecord.general.status${data.status}`);
        },
      },
    ];
    const aesexyColumns = [
      {
        title: t("betRecord.bet"),
        dataIndex: "bet_point",
        render: (data) => {
          return moneyFormat(data?.bet_point);
        },
      },
      {
        title: t("betRecord.winAmount"),
        dataIndex: "total_win_lose",
        render: (data) => {
          const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
          return renderGeneralWinlost({
            total_win_lose: data.total_win_lose,
            status: data.status,
            showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          });
        },
      },
      {
        title: t("betRecord.game.type"),
        dataIndex: "name",
      },
      {
        title: t("betRecord.transId"),
        dataIndex: "trans_id",
        collapse: true,
        render: (data) => renderCopyableTransId(data),
      },
      {
        title: t("betRecord.settleTime"),
        dataIndex: "settlement_time",
        collapse: true,
      },
      {
        title: t("betRecord.status"),
        dataIndex: "status",
        collapse: true,
        render: (data) => {
          return t(`betRecord.general.status${data.status}`);
        },
      },
    ];
    const spribeoneColumns = [
      {
        title: t("betRecord.bet"),
        dataIndex: "bet_point",
        render: (data) => {
          return moneyFormat(data?.bet_point);
        },
      },
      {
        title: t("betRecord.winAmount"),
        dataIndex: "total_win_lose",
        render: (data) => {
          const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
          return renderGeneralWinlost({
            total_win_lose: data.total_win_lose,
            status: data.status,
            showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          });
        },
      },
      {
        title: t("betRecord.game.type"),
        dataIndex: "name",
      },
      {
        title: t("betRecord.transId"),
        dataIndex: "trans_id",
        collapse: true,
        render: (data) => renderCopyableTransId(data),
      },
      {
        title: t("betRecord.settleTime"),
        dataIndex: "settlement_time",
        collapse: true,
      },
      {
        title: t("betRecord.status"),
        dataIndex: "status",
        collapse: true,
        render: (data) => {
          return t(`betRecord.general.status${data.status}`);
        },
      },
    ];
    const wesportColumns = [
      {
        title: t("betRecord.bet"),
        dataIndex: "bet_point",
        render: (data) => {
          return moneyFormat(data?.bet_point);
        },
      },
      {
        title: t("betRecord.winAmount"),
        dataIndex: "total_win_lose",
        render: (data) => {
          const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
          return renderGeneralWinlost({
            total_win_lose: data.total_win_lose,
            status: data.status,
            showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          });
        },
      },
      {
        title: t("betRecord.game.type"),
        dataIndex: "name",
      },
      {
        title: t("betRecord.transId"),
        dataIndex: "trans_id",
        collapse: true,
        render: (data) => renderCopyableTransId(data),
      },
      {
        title: t("betRecord.settleTime"),
        dataIndex: "settlement_time",
        collapse: true,
      },
      {
        title: t("betRecord.status"),
        dataIndex: "status",
        collapse: true,
        render: (data) => {
          return t(`betRecord.general.status${data.status}`);
        },
      },
    ];
    const luckySportColumns = [
      {
        title: t("betRecord.bet"),
        dataIndex: "bet_point",
        render: (data) => {
          return moneyFormat(data?.bet_point);
        },
      },
      {
        title: t("betRecord.winAmount"),
        dataIndex: "earn_point",
        render: (data) => {
          const SHOW_WIN_LOSS_STATUS = [1, 4, 5];
          return renderGeneralWinlost({
            total_win_lose: data?.earn_point,
            status: data?.status,
            showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          });
        },
      },
      {
        title: t("betRecord.game.type"),
        dataIndex: "sport_name",
        render: (data) => {
          if (data?.bet_details?.bets.length <= 1) {
            return data?.bet_details?.bets[0]?.sport_name;
          } else {
            return t("betRecord.saba.parlay");
          }
        },
      },
      {
        title: t("betRecord.transId"),
        dataIndex: "trans_id",
        collapse: true,
        render: (data) => renderCopyableTransId(data),
      },
      {
        title: t("betRecord.settleTime"),
        dataIndex: "settlement_time",
        collapse: true,
        render: (data) => data?.settlement_time || "-",
      },
      {
        title: t("betRecord.league"),
        dataIndex: "league_name",
        collapse: true,
        render: (data) => {
          if (data?.bet_details?.bets.length <= 1) {
            return data?.bet_details?.bets[0]?.tournament_name;
          } else {
            return t("betRecord.saba.parlay");
          }
        },
      },
      {
        title: t("betRecord.homeTeam"),
        dataIndex: "home_name",
        collapse: true,
        render: (data) => {
          if (data?.bet_details?.bets.length <= 1) {
            return data?.bet_details?.bets[0]?.competitor_name[0];
          } else {
            return t("betRecord.saba.parlay");
          }
        },
      },
      {
        title: t("betRecord.awayTeam"),
        dataIndex: "away_name",
        collapse: true,
        render: (data) => {
          if (data?.bet_details?.bets.length <= 1) {
            return data?.bet_details?.bets[0]?.competitor_name[1];
          } else {
            return t("betRecord.saba.parlay");
          }
        },
      },
      {
        title: t("betRecord.status"),
        dataIndex: "status",
        collapse: true,
        render: (data) => {
          return <>{t(`betRecord.t1.status${data?.status}`)}</>;
        },
      },
    ];
    const ybslotColumns = [
      {
        title: t("betRecord.bet"),
        dataIndex: "bet_point",
        render: (data) => {
          return moneyFormat(data?.bet_point);
        },
      },
      {
        title: t("betRecord.winAmount"),
        dataIndex: "total_win_lose",
        render: (data) => {
          const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
          return renderGeneralWinlost({
            total_win_lose: data.total_win_lose,
            status: data.status,
            showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          });
        },
      },
      {
        title: t("betRecord.game.type"),
        dataIndex: "name",
      },
      {
        title: t("betRecord.transId"),
        dataIndex: "trans_id",
        collapse: true,
        render: (data) => renderCopyableTransId(data),
      },
      {
        title: t("betRecord.settleTime"),
        dataIndex: "settlement_time",
        collapse: true,
      },
      {
        title: t("betRecord.status"),
        dataIndex: "status",
        collapse: true,
        render: (data) => {
          return t(`betRecord.general.status${data.status}`);
        },
      },
    ];
    const wefishColumns = [
      {
        title: t("betRecord.bet"),
        dataIndex: "bet_point",
        render: (data) => {
          return moneyFormat(data?.bet_point);
        },
      },
      {
        title: t("betRecord.winAmount"),
        dataIndex: "total_win_lose",
        render: (data) => {
          const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
          return renderGeneralWinlost({
            total_win_lose: data.total_win_lose,
            status: data.status,
            showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          });
        },
      },
      {
        title: t("betRecord.game.type"),
        dataIndex: "name",
      },
      {
        title: t("betRecord.transId"),
        dataIndex: "trans_id",
        collapse: true,
        render: (data) => renderCopyableTransId(data),
      },
      {
        title: t("betRecord.settleTime"),
        dataIndex: "settlement_time",
        collapse: true,
      },
      {
        title: t("betRecord.status"),
        dataIndex: "status",
        collapse: true,
        render: (data) => {
          return t(`betRecord.general.status${data.status}`);
        },
      },
    ];
    const weslotColumns = [
      {
        title: t("betRecord.bet"),
        dataIndex: "bet_point",
        render: (data) => {
          return moneyFormat(data?.bet_point);
        },
      },
      {
        title: t("betRecord.winAmount"),
        dataIndex: "total_win_lose",
        render: (data) => {
          const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
          return renderGeneralWinlost({
            total_win_lose: data.total_win_lose,
            status: data.status,
            showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          });
        },
      },
      {
        title: t("betRecord.game.type"),
        dataIndex: "name",
      },
      {
        title: t("betRecord.transId"),
        dataIndex: "trans_id",
        collapse: true,
        render: (data) => renderCopyableTransId(data),
      },
      {
        title: t("betRecord.settleTime"),
        dataIndex: "settlement_time",
        collapse: true,
      },
      {
        title: t("betRecord.status"),
        dataIndex: "status",
        collapse: true,
        render: (data) => {
          return t(`betRecord.general.status${data.status}`);
        },
      },
    ];
    const fcFishColumns = [
      {
        title: t("betRecord.bet"),
        dataIndex: "bet_point",
        render: (data) => {
          return moneyFormat(data?.bet_point);
        },
      },
      {
        title: t("betRecord.winAmount"),
        dataIndex: "total_win_lose",
        render: (data) => {
          const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
          return renderGeneralWinlost({
            total_win_lose: data.total_win_lose,
            status: data.status,
            showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          });
        },
      },
      {
        title: t("betRecord.game.type"),
        dataIndex: "name",
      },
      {
        title: t("betRecord.transId"),
        dataIndex: "trans_id",
        collapse: true,
        render: (data) => renderCopyableTransId(data),
      },
      {
        title: t("betRecord.settleTime"),
        dataIndex: "settlement_time",
        collapse: true,
      },
      {
        title: t("betRecord.status"),
        dataIndex: "status",
        collapse: true,
        render: (data) => {
          return t(`betRecord.general.status${data.status}`);
        },
      },
    ];
    const jdbFishColumns = [
      {
        title: t("betRecord.bet"),
        dataIndex: "bet_point",
        render: (data) => {
          return moneyFormat(data?.bet_point);
        },
      },
      {
        title: t("betRecord.winAmount"),
        dataIndex: "total_win_lose",
        render: (data) => {
          const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
          return renderGeneralWinlost({
            total_win_lose: data.total_win_lose,
            status: data.status,
            showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          });
        },
      },
      {
        title: t("betRecord.game.type"),
        dataIndex: "name",
      },
      {
        title: t("betRecord.transId"),
        dataIndex: "trans_id",
        collapse: true,
        render: (data) => renderCopyableTransId(data),
      },
      {
        title: t("betRecord.settleTime"),
        dataIndex: "settlement_time",
        collapse: true,
      },
      {
        title: t("betRecord.status"),
        dataIndex: "status",
        collapse: true,
        render: (data) => {
          return t(`betRecord.general.status${data.status}`);
        },
      },
    ];
    const jdbSlotColumns = [
      {
        title: t("betRecord.bet"),
        dataIndex: "bet_point",
        render: (data) => {
          return moneyFormat(data?.bet_point);
        },
      },
      {
        title: t("betRecord.winAmount"),
        dataIndex: "total_win_lose",
        render: (data) => {
          const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
          return renderGeneralWinlost({
            total_win_lose: data.total_win_lose,
            status: data.status,
            showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          });
        },
      },
      {
        title: t("betRecord.game.type"),
        dataIndex: "name",
      },
      {
        title: t("betRecord.transId"),
        dataIndex: "trans_id",
        collapse: true,
        render: (data) => renderCopyableTransId(data),
      },
      {
        title: t("betRecord.settleTime"),
        dataIndex: "settlement_time",
        collapse: true,
      },
      {
        title: t("betRecord.status"),
        dataIndex: "status",
        collapse: true,
        render: (data) => {
          return t(`betRecord.general.status${data.status}`);
        },
      },
    ];
    const viaCasinoLiveColumns = [
      {
        title: t("betRecord.bet"),
        dataIndex: "bet_point",
        render: (data) => {
          return moneyFormat(data?.bet_point);
        },
      },
      {
        title: t("betRecord.winAmount"),
        dataIndex: "earn_point",
        render: (data) => {
          const SHOW_WIN_LOSS_STATUS = [1, 4, 5];
          return renderGeneralWinlost({
            total_win_lose: data?.earn_point,
            status: data?.status,
            showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          });
        },
      },
      {
        title: t("betRecord.game.type"),
        dataIndex: "name",
      },
      {
        title: t("betRecord.transId"),
        dataIndex: "trans_id",
        collapse: true,
        render: (data) => renderCopyableTransId(data),
      },
      {
        title: t("betRecord.settleTime"),
        dataIndex: "settlement_time",
        collapse: true,
      },
      {
        title: t("betRecord.status"),
        dataIndex: "status",
        collapse: true,
        render: (data) => {
          return t(`betRecord.t1.status${data.status}`);
        },
      },
    ];
    const fffLiveColumns = [
      {
        title: t("betRecord.bet"),
        dataIndex: "bet_point",
        render: (data) => {
          return moneyFormat(data?.bet_point);
        },
      },
      {
        title: t("betRecord.winAmount"),
        dataIndex: "total_win_lose",
        render: (data) => {
          const SHOW_WIN_LOSS_STATUS = [1, 2, 3];
          const UNSETTLE_STATUS = [0];
          return renderGeneralWinlost({
            total_win_lose: data?.total_win_lose,
            status: data?.status,
            showWinLostStatus: SHOW_WIN_LOSS_STATUS,
            unsettleStatus: UNSETTLE_STATUS,
          });
        },
      },
      {
        title: t("betRecord.game.type"),
        dataIndex: "name",
      },
      {
        title: t("betRecord.transId"),
        dataIndex: "trans_id",
        collapse: true,
        render: (data) => renderCopyableTransId(data),
      },
      {
        title: t("betRecord.settleTime"),
        dataIndex: "settlement_time",
        collapse: true,
      },
      {
        title: t("betRecord.status"),
        dataIndex: "status",
        collapse: true,
        render: (data) => {
          return t(`betRecord.general.status${data.status}`);
        },
      },
    ];
    const wcfColumns = [
      {
        title: t("betRecord.bet"),
        dataIndex: "bet_point",
        render: (data) => {
          return moneyFormat(data?.bet_point);
        },
      },
      {
        title: t("betRecord.winAmount"),
        dataIndex: "total_win_lose",
        render: (data) => {
          const SHOW_WIN_LOSS_STATUS = [1, 2, 3];
          const UNSETTLE_STATUS = [0];
          return renderGeneralWinlost({
            total_win_lose: data?.total_win_lose,
            status: data?.status,
            showWinLostStatus: SHOW_WIN_LOSS_STATUS,
            unsettleStatus: UNSETTLE_STATUS,
          });
        },
      },
      {
        title: t("betRecord.game.type"),
        dataIndex: "name",
      },
      {
        title: t("betRecord.transId"),
        dataIndex: "trans_id",
        collapse: true,
        render: (data) => renderCopyableTransId(data),
      },
      {
        title: t("betRecord.settleTime"),
        dataIndex: "settlement_time",
        collapse: true,
      },
      {
        title: t("betRecord.status"),
        dataIndex: "status",
        collapse: true,
        render: (data) => {
          return t(`betRecord.general.status${data.status}`);
        },
      },
    ];
    const minigameColumns = [
      {
        title: t("betRecord.bet"),
        dataIndex: "bet_point",
        render: (data) => {
          return moneyFormat(data?.bet_point);
        },
      },
      {
        title: t("game.winlottery.betContent"),
        dataIndex: "multiplier",
        render: (data) => {
          switch (data.game_type) {
            case "COMLUCKY7":
              return t(`minigame.bettype.${data?.choice_number}`);
            default:
              return data?.multiplier;
          }
        },
      },
      {
        title: t("betRecord.winAmount"),
        dataIndex: "earn_point",
        render: (data) => {
          const SHOW_WIN_LOSS_STATUS = [1, 2, 4, 5];
          return renderGeneralWinlost({
            total_win_lose: data?.earn_point,
            status: data?.status,
            showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          });
        },
      },
      {
        title: t("betRecord.game.type"),
        dataIndex: "game_type",
        render: (data) => {
          return t(`win.betRecord.wingame.gameType.${data.game_type}`);
        },
      },
      {
        title: t("betRecord.transId"),
        dataIndex: "trans_id",
        collapse: true,
        render: (data) => renderCopyableTransId(data),
      },
      {
        title: t("betRecord.settleTime"),
        dataIndex: "settlement_time",
        collapse: true,
      },
      {
        title: t("betRecord.status"),
        dataIndex: "status",
        collapse: true,
        render: (data) => {
          return t(`betRecord.general.status${data.status}`);
        },
      },
    ];
    const onejdbSlotColumns = [
      {
        title: t("betRecord.bet"),
        dataIndex: "bet_point",
        render: (data) => {
          return moneyFormat(data?.bet_point);
        },
      },
      {
        title: t("betRecord.winAmount"),
        dataIndex: "total_win_lose",
        render: (data) => {
          const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
          return renderGeneralWinlost({
            total_win_lose: data.total_win_lose,
            status: data.status,
            showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          });
        },
      },
      {
        title: t("betRecord.game.type"),
        dataIndex: "name",
      },
      {
        title: t("betRecord.transId"),
        dataIndex: "trans_id",
        collapse: true,
        render: (data) => renderCopyableTransId(data),
      },
      {
        title: t("betRecord.settleTime"),
        dataIndex: "settlement_time",
        collapse: true,
      },
      {
        title: t("betRecord.status"),
        dataIndex: "status",
        collapse: true,
        render: (data) => {
          return t(`betRecord.general.status${data.status}`);
        },
      },
    ];
    const onejdbFishColumns = [
      {
        title: t("betRecord.bet"),
        dataIndex: "bet_point",
        render: (data) => {
          return moneyFormat(data?.bet_point);
        },
      },
      {
        title: t("betRecord.winAmount"),
        dataIndex: "total_win_lose",
        render: (data) => {
          const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
          return renderGeneralWinlost({
            total_win_lose: data.total_win_lose,
            status: data.status,
            showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          });
        },
      },
      {
        title: t("betRecord.game.type"),
        dataIndex: "name",
      },
      {
        title: t("betRecord.transId"),
        dataIndex: "trans_id",
        collapse: true,
        render: (data) => renderCopyableTransId(data),
      },
      {
        title: t("betRecord.settleTime"),
        dataIndex: "settlement_time",
        collapse: true,
      },
      {
        title: t("betRecord.status"),
        dataIndex: "status",
        collapse: true,
        render: (data) => {
          return t(`betRecord.general.status${data.status}`);
        },
      },
    ];
    const oneppColumns = [
      {
        title: t("betRecord.bet"),
        dataIndex: "bet_point",
        render: (data) => {
          return moneyFormat(data?.bet_point);
        },
      },
      {
        title: t("betRecord.winAmount"),
        dataIndex: "total_win_lose",
        render: (data) => {
          const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
          return renderGeneralWinlost({
            total_win_lose: data.total_win_lose,
            status: data.status,
            showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          });
        },
      },
      {
        title: t("betRecord.game.type"),
        dataIndex: "name",
      },
      {
        title: t("betRecord.transId"),
        dataIndex: "trans_id",
        collapse: true,
        render: (data) => renderCopyableTransId(data),
      },
      {
        title: t("betRecord.settleTime"),
        dataIndex: "settlement_time",
        collapse: true,
      },
      {
        title: t("betRecord.status"),
        dataIndex: "status",
        collapse: true,
        render: (data) => {
          return t(`betRecord.general.status${data.status}`);
        },
      },
    ];
    const onepgColumns = [
      {
        title: t("betRecord.bet"),
        dataIndex: "bet_point",
        render: (data) => {
          return moneyFormat(data?.bet_point);
        },
      },
      {
        title: t("betRecord.winAmount"),
        dataIndex: "total_win_lose",
        render: (data) => {
          const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
          return renderGeneralWinlost({
            total_win_lose: data.total_win_lose,
            status: data.status,
            showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          });
        },
      },
      {
        title: t("betRecord.game.type"),
        dataIndex: "name",
      },
      {
        title: t("betRecord.transId"),
        dataIndex: "trans_id",
        collapse: true,
        render: (data) => renderCopyableTransId(data),
      },
      {
        title: t("betRecord.settleTime"),
        dataIndex: "settlement_time",
        collapse: true,
      },
      {
        title: t("betRecord.status"),
        dataIndex: "status",
        collapse: true,
        render: (data) => {
          return t(`betRecord.general.status${data.status}`);
        },
      },
    ];
    const onehacksawColumns = [
      {
        title: t("betRecord.bet"),
        dataIndex: "bet_point",
        render: (data) => {
          return moneyFormat(data?.bet_point);
        },
      },
      {
        title: t("betRecord.winAmount"),
        dataIndex: "total_win_lose",
        render: (data) => {
          const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
          return renderGeneralWinlost({
            total_win_lose: data.total_win_lose,
            status: data.status,
            showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          });
        },
      },
      {
        title: t("betRecord.game.type"),
        dataIndex: "name",
      },
      {
        title: t("betRecord.transId"),
        dataIndex: "trans_id",
        collapse: true,
        render: (data) => renderCopyableTransId(data),
      },
      {
        title: t("betRecord.settleTime"),
        dataIndex: "settlement_time",
        collapse: true,
      },
      {
        title: t("betRecord.status"),
        dataIndex: "status",
        collapse: true,
        render: (data) => {
          return t(`betRecord.general.status${data.status}`);
        },
      },
    ];
    const onejilislotColumns = [
      {
        title: t("betRecord.bet"),
        dataIndex: "bet_point",
        render: (data) => {
          return moneyFormat(data?.bet_point);
        },
      },
      {
        title: t("betRecord.winAmount"),
        dataIndex: "total_win_lose",
        render: (data) => {
          const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
          return renderGeneralWinlost({
            total_win_lose: data.total_win_lose,
            status: data.status,
            showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          });
        },
      },
      {
        title: t("betRecord.game.type"),
        dataIndex: "name",
      },
      {
        title: t("betRecord.transId"),
        dataIndex: "trans_id",
        collapse: true,
        render: (data) => renderCopyableTransId(data),
      },
      {
        title: t("betRecord.settleTime"),
        dataIndex: "settlement_time",
        collapse: true,
      },
      {
        title: t("betRecord.status"),
        dataIndex: "status",
        collapse: true,
        render: (data) => {
          return t(`betRecord.general.status${data.status}`);
        },
      },
    ];
    const onejilifishColumns = [
      {
        title: t("betRecord.bet"),
        dataIndex: "bet_point",
        render: (data) => {
          return moneyFormat(data?.bet_point);
        },
      },
      {
        title: t("betRecord.winAmount"),
        dataIndex: "total_win_lose",
        render: (data) => {
          const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
          return renderGeneralWinlost({
            total_win_lose: data.total_win_lose,
            status: data.status,
            showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          });
        },
      },
      {
        title: t("betRecord.game.type"),
        dataIndex: "name",
      },
      {
        title: t("betRecord.transId"),
        dataIndex: "trans_id",
        collapse: true,
        render: (data) => renderCopyableTransId(data),
      },
      {
        title: t("betRecord.settleTime"),
        dataIndex: "settlement_time",
        collapse: true,
      },
      {
        title: t("betRecord.status"),
        dataIndex: "status",
        collapse: true,
        render: (data) => {
          return t(`betRecord.general.status${data.status}`);
        },
      },
    ];
    const onejilicardColumns = [
      {
        title: t("betRecord.bet"),
        dataIndex: "bet_point",
        render: (data) => {
          return moneyFormat(data?.bet_point);
        },
      },
      {
        title: t("betRecord.winAmount"),
        dataIndex: "total_win_lose",
        render: (data) => {
          const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
          return renderGeneralWinlost({
            total_win_lose: data.total_win_lose,
            status: data.status,
            showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          });
        },
      },
      {
        title: t("betRecord.game.type"),
        dataIndex: "name",
      },
      {
        title: t("betRecord.transId"),
        dataIndex: "trans_id",
        collapse: true,
        render: (data) => renderCopyableTransId(data),
      },
      {
        title: t("betRecord.settleTime"),
        dataIndex: "settlement_time",
        collapse: true,
      },
      {
        title: t("betRecord.status"),
        dataIndex: "status",
        collapse: true,
        render: (data) => {
          return t(`betRecord.general.status${data.status}`);
        },
      },
    ];
    const onejilicasinoColumns = [
      {
        title: t("betRecord.bet"),
        dataIndex: "bet_point",
        render: (data) => {
          return moneyFormat(data?.bet_point);
        },
      },
      {
        title: t("betRecord.winAmount"),
        dataIndex: "total_win_lose",
        render: (data) => {
          const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
          return renderGeneralWinlost({
            total_win_lose: data.total_win_lose,
            status: data.status,
            showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          });
        },
      },
      {
        title: t("betRecord.game.type"),
        dataIndex: "name",
      },
      {
        title: t("betRecord.transId"),
        dataIndex: "trans_id",
        collapse: true,
        render: (data) => renderCopyableTransId(data),
      },
      {
        title: t("betRecord.settleTime"),
        dataIndex: "settlement_time",
        collapse: true,
      },
      {
        title: t("betRecord.status"),
        dataIndex: "status",
        collapse: true,
        render: (data) => {
          return t(`betRecord.general.status${data.status}`);
        },
      },
    ];
    const oneevoliveColumns = [
      {
        title: t("betRecord.bet"),
        dataIndex: "bet_point",
        render: (data) => {
          return moneyFormat(data?.bet_point);
        },
      },
      {
        title: t("betRecord.winAmount"),
        dataIndex: "total_win_lose",
        render: (data) => {
          const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
          return renderGeneralWinlost({
            total_win_lose: data.total_win_lose,
            status: data.status,
            showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          });
        },
      },
      {
        title: t("betRecord.game.type"),
        dataIndex: "name",
      },
      {
        title: t("betRecord.transId"),
        dataIndex: "trans_id",
        collapse: true,
        render: (data) => renderCopyableTransId(data),
      },
      {
        title: t("betRecord.settleTime"),
        dataIndex: "settlement_time",
        collapse: true,
      },
      {
        title: t("betRecord.status"),
        dataIndex: "status",
        collapse: true,
        render: (data) => {
          return t(`betRecord.general.status${data.status}`);
        },
      },
    ];
    const oneppliveColumns = [
      {
        title: t("betRecord.bet"),
        dataIndex: "bet_point",
        render: (data) => {
          return moneyFormat(data?.bet_point);
        },
      },
      {
        title: t("betRecord.winAmount"),
        dataIndex: "total_win_lose",
        render: (data) => {
          const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
          return renderGeneralWinlost({
            total_win_lose: data.total_win_lose,
            status: data.status,
            showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          });
        },
      },
      {
        title: t("betRecord.game.type"),
        dataIndex: "name",
      },
      {
        title: t("betRecord.transId"),
        dataIndex: "trans_id",
        collapse: true,
        render: (data) => renderCopyableTransId(data),
      },
      {
        title: t("betRecord.settleTime"),
        dataIndex: "settlement_time",
        collapse: true,
      },
      {
        title: t("betRecord.status"),
        dataIndex: "status",
        collapse: true,
        render: (data) => {
          return t(`betRecord.general.status${data.status}`);
        },
      },
    ];
    const onesabaColumns = [
      {
        title: t("betRecord.bet"),
        dataIndex: "bet_point",
        render: (data) => {
          return moneyFormat(data?.bet_point);
        },
      },
      {
        title: t("betRecord.winAmount"),
        dataIndex: "total_win_lose",
        render: (data) => {
          const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
          return renderGeneralWinlost({
            total_win_lose: data.total_win_lose,
            status: data.status,
            showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          });
        },
      },
      {
        title: t("betRecord.game.type"),
        dataIndex: "name",
      },
      {
        title: t("betRecord.transId"),
        dataIndex: "trans_id",
        collapse: true,
        render: (data) => renderCopyableTransId(data),
      },
      {
        title: t("betRecord.settleTime"),
        dataIndex: "settlement_time",
        collapse: true,
      },
      {
        title: t("betRecord.status"),
        dataIndex: "status",
        collapse: true,
        render: (data) => {
          return t(`betRecord.general.status${data.status}`);
        },
      },
    ];
    const oneglobalColumns = [
      {
        title: t("betRecord.bet"),
        dataIndex: "bet_point",
        render: (data) => {
          return moneyFormat(data?.bet_point);
        },
      },
      {
        title: t("betRecord.winAmount"),
        dataIndex: "total_win_lose",
        render: (data) => {
          const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
          return renderGeneralWinlost({
            total_win_lose: data.total_win_lose,
            status: data.status,
            showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          });
        },
      },
      {
        title: t("betRecord.game.type"),
        dataIndex: "name",
      },
      {
        title: t("betRecord.transId"),
        dataIndex: "trans_id",
        collapse: true,
        render: (data) => renderCopyableTransId(data),
      },
      {
        title: t("betRecord.settleTime"),
        dataIndex: "settlement_time",
        collapse: true,
      },
      {
        title: t("betRecord.status"),
        dataIndex: "status",
        collapse: true,
        render: (data) => {
          return t(`betRecord.general.status${data.status}`);
        },
      },
    ];
    const agColumns = [
      {
        title: t("betRecord.bet"),
        dataIndex: "bet_point",
        render: (data) => {
          return moneyFormat(data?.bet_point);
        },
      },
      {
        title: t("betRecord.winAmount"),
        dataIndex: "total_win_lose",
        render: (data) => {
          const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
          return renderGeneralWinlost({
            total_win_lose: data.total_win_lose,
            status: data.status,
            showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          });
        },
      },
      {
        title: t("betRecord.game.type"),
        dataIndex: "name",
      },
      {
        title: t("betRecord.transId"),
        dataIndex: "trans_id",
        collapse: true,
        render: (data) => renderCopyableTransId(data),
      },
      {
        title: t("betRecord.settleTime"),
        dataIndex: "settlement_time",
        collapse: true,
      },
      {
        title: t("betRecord.status"),
        dataIndex: "status",
        collapse: true,
        render: (data) => {
          return t(`betRecord.general.status${data.status}`);
        },
      },
    ];
    const omgColumns = [
      {
        title: t("betRecord.bet"),
        dataIndex: "bet_point",
        render: (data) => {
          return moneyFormat(data?.bet_point);
        },
      },
      {
        title: t("betRecord.winAmount"),
        dataIndex: "total_win_lose",
        render: (data) => {
          const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
          return renderGeneralWinlost({
            total_win_lose: data.total_win_lose,
            status: data.status,
            showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          });
        },
      },
      {
        title: t("betRecord.game.type"),
        dataIndex: "name",
      },
      {
        title: t("betRecord.transId"),
        dataIndex: "trans_id",
        collapse: true,
        render: (data) => renderCopyableTransId(data),
      },
      {
        title: t("betRecord.settleTime"),
        dataIndex: "settlement_time",
        collapse: true,
      },
      {
        title: t("betRecord.status"),
        dataIndex: "status",
        collapse: true,
        render: (data) => {
          return t(`betRecord.general.status${data.status}`);
        },
      },
    ];
    const sboSportColumns = [
      {
        title: t("betRecord.bet"),
        dataIndex: "bet_point",
        render: (data) => {
          return moneyFormat(data?.bet_point);
        },
      },
      {
        title: t("betRecord.winAmount"),
        dataIndex: "total_win_lose",
        render: (data) => {
          const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
          return renderGeneralWinlost({
            total_win_lose: data.total_win_lose,
            status: data.status,
            showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          });
        },
      },
      {
        title: t("betRecord.game.type"),
        dataIndex: "name",
      },
      {
        title: t("betRecord.transId"),
        dataIndex: "trans_id",
        collapse: true,
        render: (data) => renderCopyableTransId(data),
      },
      {
        title: t("betRecord.settleTime"),
        dataIndex: "settlement_time",
        collapse: true,
      },
      {
        title: t("betRecord.status"),
        dataIndex: "status",
        collapse: true,
        render: (data) => {
          return t(`betRecord.general.status${data.status}`);
        },
      },
    ];
    const crSportColumns = [
      {
        title: t("betRecord.bet"),
        dataIndex: "bet_point",
        render: (data) => {
          return moneyFormat(data?.bet_point);
        },
      },
      {
        title: t("betRecord.winAmount"),
        dataIndex: "total_win_lose",
        render: (data) => {
          const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
          return renderGeneralWinlost({
            total_win_lose: data.total_win_lose,
            status: data.status,
            showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          });
        },
      },
      {
        title: t("betRecord.game.type"),
        dataIndex: "name",
      },
      {
        title: t("betRecord.transId"),
        dataIndex: "trans_id",
        collapse: true,
        render: (data) => renderCopyableTransId(data),
      },
      {
        title: t("betRecord.settleTime"),
        dataIndex: "settlement_time",
        collapse: true,
      },
      {
        title: t("betRecord.status"),
        dataIndex: "status",
        collapse: true,
        render: (data) => {
          return t(`betRecord.general.status${data.status}`);
        },
      },
    ];
    const fbSportColumns = [
      {
        title: t("betRecord.bet"),
        dataIndex: "bet_point",
        render: (data) => {
          return moneyFormat(data?.bet_point);
        },
      },
      {
        title: t("betRecord.winAmount"),
        dataIndex: "total_win_lose",
        render: (data) => {
          const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
          return renderGeneralWinlost({
            total_win_lose: data.total_win_lose,
            status: data.status,
            showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          });
        },
      },
      {
        title: t("betRecord.game.type"),
        dataIndex: "game_name",
      },
      {
        title: t("betRecord.transId"),
        dataIndex: "trans_id",
        collapse: true,
        render: (data) => renderCopyableTransId(data),
      },
      {
        title: t("betRecord.settleTime"),
        dataIndex: "settlement_time",
        collapse: true,
      },
      {
        title: t("betRecord.status"),
        dataIndex: "status",
        collapse: true,
        render: (data) => {
          return t(`betRecord.general.status${data.status}`);
        },
      },
    ];

    const defaultColumns = [
      {
        title: t("betRecord.bet"),
        dataIndex: "stake",
        render: (data) => {
          return moneyFormat(data?.stake);
        },
      },
      {
        title: t("betRecord.winAmount"),
        dataIndex: "winlost_amount",
        render: (data) => {
          return data?.winlost_amount === null ? (
            t("betRecord.unsettled")
          ) : (
            <span
              style={{
                color:
                  data?.winlost_amount > 0
                    ? "var(--color-system-success)"
                    : "var(--color-system-error)",
              }}
            >
              {moneyFormat(data?.winlost_amount)}
            </span>
          );
        },
      },
      {
        title: t("betRecord.transId"),
        dataIndex: "trans_id",
        render: (data) => {
          return (
            <div
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <span style={{ marginRight: "2px" }}>{data.trans_id}</span>
              <span
                onClick={() => {
                  copyText(data.trans_id, t("normal.copy.complete"));
                }}
                style={{ cursor: "pointer" }}
              >
                <CopyIcon />
              </span>
            </div>
          );
        },
      },
      {
        title: t("betRecord.settleTime"),
        dataIndex: "settlement_time",
        collapse: true,
      },
      {
        title: t("betRecord.status"),
        dataIndex: "status",
        collapse: true,
        render: (data) => {
          return t(`betRecord.general.status${data.status}`);
        },
      },
    ];
    const columnsDict = {
      saba: sabaColumns,
      jollysport: jollySportColumns,
      blockchain: blockchainColumns,
      bglottery: bglotteryColumns,
      "77lottery": lottery77Columns,
      winlottery: winColumns,
      mg: mgColumns,
      t1: t1Columns,
      evo: evoColumns,
      pp: ppColumns,
      pg: pgColumns,
      ygg: yggColumns,
      evoplay: evoplayColumns,
      jili: jiliColumns,
      jdb: spribeColumns,
      pt: ptColumns,
      pplive: ppliveColumns,
      fc: fcColumns,
      cq9: cq9Columns,
      playstar: playstarColumns,
      welive: weliveColumns,
      weblockchain: weblockchainColumns,
      welottery: welotteryColumns,
      jilifish: jilifishColumns,
      tcg: tcgColumns,
      youbet: youbetColumns,
      aesexy: aesexyColumns,
      spribeone: spribeoneColumns,
      wesport: wesportColumns,
      luckysport: luckySportColumns,
      ybslot: ybslotColumns,
      weslot: weslotColumns,
      wefish: wefishColumns,
      fcfish: fcFishColumns,
      jdbfish: jdbFishColumns,
      jdbslot: jdbSlotColumns,
      viacasinolive: viaCasinoLiveColumns,
      ffflive: fffLiveColumns,
      wcf: wcfColumns,
      minigame: minigameColumns,
      onejdbfish: onejdbFishColumns,
      onejdbslot: onejdbSlotColumns,
      onepp: oneppColumns,
      onepg: onepgColumns,
      onehacksaw: onehacksawColumns,
      onejilislot: onejilislotColumns,
      onejilifish: onejilifishColumns,
      onejilicard: onejilicardColumns,
      onejilicasino: onejilicasinoColumns,
      oneevolive: oneevoliveColumns,
      onepplive: oneppliveColumns,
      onesaba: onesabaColumns,
      onehabaneropoker: oneglobalColumns,
      onekingmidaspoker: oneglobalColumns,
      onekypoker: oneglobalColumns,
      one365poker: oneglobalColumns,
      onegtfslot: oneglobalColumns,
      onemicroslot: oneglobalColumns,
      onespadeslot: oneglobalColumns,
      onerelaxslot: oneglobalColumns,
      onehabaneroslot: oneglobalColumns,
      onenetentslot: oneglobalColumns,
      oneredtigerslot: oneglobalColumns,
      onebigtimeslot: oneglobalColumns,
      onenolimitcityslot: oneglobalColumns,
      onebngslot: oneglobalColumns,
      oneadvantplayslot: oneglobalColumns,
      oneevoplayslot: oneglobalColumns,
      onekingmidasslot: oneglobalColumns,
      oneepicwinslot: oneglobalColumns,
      onelive22slot: oneglobalColumns,
      onecgslot: oneglobalColumns,
      onedbslot: oneglobalColumns,
      onethunderkickslot: oneglobalColumns,
      onepaslot: oneglobalColumns,
      oneplaytechslot: oneglobalColumns,
      onealizeslot: oneglobalColumns,
      oneavataruxslot: oneglobalColumns,
      onethebetterslot: oneglobalColumns,
      oneendorphinaslot: oneglobalColumns,
      onelucky365slot: oneglobalColumns,
      onewinfinitylive: oneglobalColumns,
      oneyeebetlive: oneglobalColumns,
      oneezugilive: oneglobalColumns,
      onemicrolive: oneglobalColumns,
      onepalive: oneglobalColumns,
      oneaasexylive: oneglobalColumns,
      onewmlive: oneglobalColumns,
      oneplaytechlive: oneglobalColumns,
      onedblive: oneglobalColumns,
      onecq9live: oneglobalColumns,
      onebiglive: oneglobalColumns,
      onealizemini: oneglobalColumns,
      oneaviatrixmini: oneglobalColumns,
      onelitemini: oneglobalColumns,
      oneaviatormini: oneglobalColumns,
      onemicroarcade: oneglobalColumns,
      agjilislot: agColumns,
      agpgslot: agColumns,
      agppslot: agColumns,
      agjdbslot: agColumns,
      agbgslot: agColumns,
      agfcslot: agColumns,
      agcpslot: agColumns,
      agwgslot: agColumns,
      agtadaslot: agColumns,
      aghsdslot: agColumns,
      omgspribe: omgColumns,
      omgpgslot: omgColumns,
      omgppslot: omgColumns,
      omghacksaw: omgColumns,
      omgjilislot: omgColumns,
      omgminigame: omgColumns,
      omgtadaslot: omgColumns,
      omgcpslot: omgColumns,
      omgaskmeslot: omgColumns,
      omglottery: omgColumns,
      omgcasino: omgColumns,
      omgjdbslot: omgColumns,
      omgwgslot: omgColumns,
      omg759slot: omgColumns,
      omgredtiger: omgColumns,
      omgfcslot: omgColumns,
      omgigtslot: omgColumns,
      omg2jgame: omgColumns,
      omgslotmill: omgColumns,
      omggameartslot: omgColumns,
      sbosport: sboSportColumns,
      crsport: crSportColumns,
      fbsport: fbSportColumns,
      default: defaultColumns,
    };
    return columnsDict[game] ?? defaultColumns;
  };

  return <ColumnsContext.Provider value={{ getColumns }}>{props.children}</ColumnsContext.Provider>;
};

// export default Columns;
export const useGetColumns = () => {
  const _columnsContext = useContext(ColumnsContext);
  return _columnsContext;
};
